
import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { ItemView } from '~/assets/ts/items/itemView'
export default defineComponent({
  components: {},
  props: {
    itemObj: ItemView,
    pageStr: String,
    loadingSessions: Number,
  },
  setup(props) {
    const editParameter = ref('')

    const possibleVariations = computed(() => {
      const variations: {
        idx: string
        desc: string
        cta: string
        title: string
        link: string
        list: {
          match: boolean
          slug: string
          desc: string
          price: number
        }[]
      }[] = []
      if (props.itemObj) {

        let getMetals = props.itemObj.getMetals()

        if (getMetals.length > 1) {
          variations.push({
            idx: 'metals',
            desc: getMetals.filter((x) => x.match)[0].desc,
            cta: '.metals.cta',
            title: '.metals.title',
            link: '.metals.alloyLink',
            list: getMetals,
          })
        }

        let getJewellerySizes = props.itemObj.getJewellerySizes()

        if (getJewellerySizes.length > 1) {

          variations.push({
            idx: 'sizes',
            desc: getJewellerySizes.filter((x) => x.match)[0].desc,
            cta: '.sizes.cta',
            title: '.sizes.title',
            link: '.sizes.diamondLink',
            list: getJewellerySizes,
          })
        }

        let getJewelleryStonePools = props.itemObj.getJewelleryStonePools()

        if (getJewelleryStonePools.length > 1) {

          variations.push({
            idx: 'stonePools',
            desc: getJewelleryStonePools.filter((x) => x.match)[0].desc,
            cta: '.stonePool.cta',
            title: '.stonePool.title',
            link: '.stonePool.diamondLink',
            list: getJewelleryStonePools,
          })
        }

        let getJewelleryQualities = props.itemObj.getJewelleryQualities()

        if (getJewelleryQualities.length > 1) {

          variations.push({
            idx: 'quality',
            desc: getJewelleryQualities.filter((x) => x.match)[0].desc,
            cta: '.quality.cta',
            title: '.quality.title',
            link: '.quality.diamondLink',
            list: getJewelleryQualities,
          })
        }

        let getJewelleryStoneNumbers = props.itemObj.getJewelleryStoneNumbers()

        if (getJewelleryStoneNumbers.length > 1) {

          variations.push({
            idx: 'numbers',
            desc: getJewelleryStoneNumbers.filter((x) => x.match)[0].desc,
            cta: '.number.cta',
            title: '.number.title',
            link: '',
            list: getJewelleryStoneNumbers,
          })
        }

        let getJewelleryFinishes = props.itemObj.getJewelleryFinishes()

        if (getJewelleryFinishes.length > 1) {
          variations.push({
            idx: 'finishes',
            desc: getJewelleryFinishes.filter((x) => x.match)[0].desc,
            cta: '.finish.cta',
            title: '.finish.title',
            link: '',
            list: getJewelleryFinishes,
          })
        }

        let getJewelleryModels = props.itemObj.getJewelleryModels()

        if (getJewelleryModels.length > 1) {
          variations.push({
            idx: 'models',
            desc: getJewelleryModels.filter((x) => x.match)[0]
              .desc,
            cta: '.model.cta',
            title: '.model.title',
            link: '',
            list: getJewelleryModels,
          })
        }
      }

      return variations
    })

    const getPossibleIconStoneSize = (stoneSizeStr: string) => {
      const possible: string[] = [
        '010',
        '015',
        '020',
        '025',
        '030',
        '040',
        '050',
        '070',
        '100',
        '150',
        '200',
      ]
      const finalStoneSite = stoneSizeStr
        .replace('.', '')
        .replace(',', '')
        .substring(0, 3)

      if (possible.includes(finalStoneSite)) {
        return finalStoneSite
      } else {
        let lastStoneSize = possible[0]
        for (const idx in possible) {
          if (possible[idx] > finalStoneSite) {
            break
          } else {
            lastStoneSize = possible[idx]
          }
        }

        return lastStoneSize
      }
    }

    const getPossibleIconStoneQuality = (stoneQuality: string) => {
      return 'white'
    }



    return {
      editParameter,
      possibleVariations,
      getPossibleIconStoneSize,
      getPossibleIconStoneQuality,
    }
  },
})
